import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestConsolidatedRequest } from './Consolidated.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportConsolidated(
  params: QuestConsolidatedRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/Consolidated`,
    params,
  )) as unknown;

  return result as BlobPart;
}
